import styled from 'styled-components';

export const StyledContainer = styled.div`
  max-width: ${props => props.theme.containerWidth};
  margin: 0 auto;
  padding: 0 15px;
`
